import { z } from '@hono/zod-openapi'
import { raffleWinnersTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export type InsertRaffleWinner = z.infer<typeof zInsertRaffleWinner>
export type SelectRaffleWinner = z.infer<typeof zSelectRaffleWinner>
export type UpdateRaffleWinner = z.infer<typeof zUpdateRaffleWinner>
export type QueryRaffleWinners = z.infer<typeof zQueryRaffleWinners>
export type ColumnsOfRaffleWinnersTable =
    keyof typeof raffleWinnersTable._.columns

export const zSelectRaffleWinner = createSelectSchema(raffleWinnersTable)
export const zInsertRaffleWinner = createInsertSchema(raffleWinnersTable).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})
export const zUpdateRaffleWinner = zInsertRaffleWinner.partial()
export const zQueryRaffleWinners = zInsertRaffleWinner
    .extend({ id: z.string(), ids: z.string().array() })
    .extend(zCommonQuery.shape)
    .partial()
